import { render } from "./ServiceItem.vue?vue&type=template&id=b27e5ebc"
import script from "./ServiceItem.vue?vue&type=script&lang=js"
export * from "./ServiceItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__